import React from 'react';
import {View, Text, StyleSheet} from 'react-native';
import useMultiBoxState from './hooks/useMultiBoxState';
import useWidth from '../scanToCartScanning/useWidth';

const MultiBoxHeader = () => {
  const windowWidth = useWidth();
  const {
    currentOrder,
    showBoxUi,
    totalScannedCount,
    boxScannedCount,
    boxOfCount,
    boxName
  } = useMultiBoxState();

  const items = currentOrder?.scanned_items;
  const multiBoxLength = currentOrder?.order_item_boxes?.length || 0;

  if (showBoxUi && items?.length > 0 && windowWidth >= 900) {
    return (
      <View
        testID="multiBox"
        style={{
          textAlign: 'center',
          backgroundColor: '#000',
          padding: multiBoxLength === 0 ? 27 : 0
        }}>
        <Text
          style={{
            color: '#D7D7D7',
            marginTop: 3,
            fontSize: 18,
            fontFamily: 'Poppins_600SemiBold'
          }}>
          {boxName}
        </Text>
        <Text
          style={{
            color: 'white',
            fontSize: 18,
            fontFamily: 'Poppins_300Light'
          }}>
          {boxScannedCount} of {boxOfCount} Scanned Items
        </Text>
      </View>
    );
  }

  if (windowWidth > 900) {
    return (
      <Text style={styles.headerTitle}>
        {totalScannedCount} Scanned Items
      </Text>
    );
  }

  return null;
};

const styles = StyleSheet.create({
  headerTitle: {
    color: '#fff',
    fontSize: 15,
    fontFamily: 'Poppins_600SemiBold',
    fontWeight: 'bold',
    backgroundColor: '#000',
    textAlign: 'center',
    paddingVertical: 10
  }
});

export default MultiBoxHeader;
